<template>
  <div class="card cardimage h-100">
    <div class="card-body h-100">
      <div class="row file-section">
        <div class="col-sm-12">
          <div class="row">
            <div class="col-12 col-sm-6">
              <label class="text-primary">{{ $t('key_pod_number') }} <span style="color:red">*</span> </label>
              <input v-model="manifest.number" class="form-control" type="text" maxLength="50" required/>
            </div>
            <div class="mt-3 col-12 col-sm-6 mt-sm-0">
              <label class="text-primary">{{ $t('key_pod_courier') }} <span style="color:red">*</span> </label>
              <input v-model="manifest.couries" class="form-control" required />
            </div>
          </div>
          <div class="row mt-4">
            <div class="mt-3 col-12 col-sm-6 mt-sm-0">
              <label class="text-primary">{{ $t('key_pod_user') }}</label>
              <input v-model="manifest.operator" class="form-control" type="text" maxLength="50" />
            </div>
            <div class="mt-3 col-12 col-sm-6 mt-sm-0">
              <label class="text-primary">{{ $t('key_pod_date') }}</label>
              <input v-model="manifest.date" class="form-control" type="date"/>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-sm-12">
              <label class="text-primary">{{ $t('key_pod_status') }} <span style="color:red">*</span> </label> 
              <hk-select v-model="manifest.status" :options="statusOptions" required> </hk-select>                     
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-sm-12 text-end">
          <button type="button" class="mt-2 mb-0 btn bg-gradient-success ms-lg-auto me-lg-0 me-auto mt-lg-0 " @click="save()">
            {{ manifest['_id'] ? $t('key_pod_save') : $t('key_pod_save_and_continue') }}
          </button>                    
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HkSelect from "@/hotaka/components/HkSelect.vue";
export default {
  name: "EditManifest",
  components: {
    HkSelect,
  },
  emits: ['save'],
  data() {
    return {
      manifest: {
        number: '',
        date: this.$dateUtils.toFormat(new Date(), 'yyyy-MM-DD'),
        operator: null,
        status: 'PENDIENTE',
        couries: null,
      },
      statusOptions:[
        {
          value: 'PENDIENTE',
          label: this.$t('key_pod_status_pending'),
          color: 'text-pending'
        },
        {
          value: 'ENTREGADO',
          label: this.$t('key_pod_status_delivered'),
          color: 'text-delivered'
        }
      ],
      manifestId: null,
    }
  },
  computed: {
    manifestData() {
      return this.$store.state.manifiest.manifest.data;
    },
  },
  watch:{
    manifestData(val) {
      if(val){
        let manifestEntity = { ...this.$store.state.manifiest.manifest.data }

        this.manifest = {
          ...manifestEntity,
          date: manifestEntity.date ? this.$dateUtils.toFormat(manifestEntity.date, 'yyyy-MM-DD') : null,
        }
      }
    },
  },
  mounted() {
    this.manifestId = this.$route.params.id;
    if(this.manifestId){
      this.$store.commit("manifiest/getManifest", this.$route.params.id);
    }
  },
  methods: {
    save() {  
      this.$emit('save', this.manifest)
      /* let form = this.$refs.editManifestForm;
      if (form.checkValidity()) {
        console.log(this.manifest)
        if(!this.manifestId || this.manifestId==''){
          // this.$store.commit("manifiest/newManifest", this.manifest);
        }
        else{
          // this.$store.commit("manifiest/updateManifest", this.manifest);
        }
      }
      form.classList.add('was-validated') */
    },
  },
};
</script>

<style lang="scss" scoped>

.noimageColorEdit{ 
  opacity: 0.1 !important;  
}


.picture-cursor {
  cursor: url('../../../assets/img/zoom-in.svg'), auto;
}

.cardimage {
  position: inherit !important;
}

.form-control:disabled{
  background-color: white;
  border: 1px solid transparent;
}
.noimageColor{ 
  opacity: 0.1 !important;
}

.back-button {
  color: #4A7062
}

.manifest-image {
  object-fit: contain;
  transition: transform .2s;
  border-radius: 10px;
  transition: all 0.2s ease-in-out;
  border-radius: 6px;
}

.file-section {
  height: 20rem;
}
</style>

 